import axios from 'axios';


// export const getOperations = (cond: string) => {
//     return axios.post(
//       process.env.REACT_APP_API_GLOBAL_URL + `operation?where=` + cond
//     );
// };
export const getOperations = (cond: string, idList?:string[]) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  if(idList){
    return axios.post(
      process.env.REACT_APP_API_GLOBAL_URL + `operation/?where=`+cond,idList,{headers}
      
      
    )
  }else{
    return axios.post(
      process.env.REACT_APP_API_GLOBAL_URL + `operation?where=` + cond
    );
  }
 
};

export const getOperationsTemplateDetail = (t_id: number) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL +
      `operation/template/detail?where=` +
      t_id
  );
};
export const EditOperations = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `gant/op/edit`, obj, {
    headers,
  });
};
export const AddOperations = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `gant/op/add`, obj, {
    headers,
  });
};
export const AddEditOperationsByTemplate = (obj: Object[]) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `gant/op/edit-temp`, obj, {
    headers,
  });
};
export const DeleteOperations = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `gant/op/delete`,
    obj,
    { headers }
  );
};
export const EditGantt = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `gant/edit`, obj, {
    headers,
  });
};
